export default __webpack_public_path__ + "static/media/userpic1.2fb7bd1e.svg";